import React, { Fragment } from 'react';

const RenderCondition = ({ children, condition }) => {
  if (!condition) return <Fragment></Fragment>;

  return children;
};

export default RenderCondition;